import { Map } from 'immutable';

import { shapePersonalizationQuestionsForApp } from '@/utils/product/shapeAttributes';
import { personalizationHasFilesUpload } from '@/utils/product/checkAttribute';
import { validatePersonalization } from '@/utils/validations/personalization';
import { clearErrors } from '@/utils/errors';
import { escapeRegex } from '@/utils/string';
import { getError } from '@/utils/bulkEdit';
import { getSize } from '@/utils/iterable/getSize';

import { ENABLED, PERSONALIZATION_TYPE, REQUIRED, VALUE } from '@/constants/product';
import { OPERATIONS } from '@/constants/bulkEdit';
import { ATTRIBUTE } from '@/constants/attributes';
import { ETSY } from '@/constants/channels';
import { FORM } from '@/constants/forms';

export default function personalization({ actions, operation, product, userFeatures }) {
  const channel = product.get('channel');

  function validateAndApply({ type, value }) {
    return {
      actions,
      product: getError({ channel, type, value })
        ? product
        : clearErrors({
          errors: [type],
          path: FORM.PERSONALIZATION,
          product: product.set(FORM.PERSONALIZATION,
            product.get(FORM.PERSONALIZATION).setIn([type, VALUE], value)
          ),
        }),
    };
  }

  switch (operation.get('type')) {
    case OPERATIONS[ETSY].PERSONALIZATION.IS_PERSONALIZABLE_SET: {
      return {
        actions,
        product: product.setIn([FORM.PERSONALIZATION, ENABLED], operation.get('value')),
      };
    }

    case OPERATIONS[ETSY].PERSONALIZATION.IS_REQUIRED_SET: {
      return {
        actions,
        product: product.setIn([FORM.PERSONALIZATION, REQUIRED], operation.get('value')),
      };
    }

    case OPERATIONS[ETSY].PERSONALIZATION.CHAR_COUNT_MAX_SET: {
      return validateAndApply({
        type: ATTRIBUTE.CHAR_COUNT_MAX,
        value: operation.get('value'),
      });
    }

    case OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_SET: {
      return validateAndApply({
        type: ATTRIBUTE.INSTRUCTIONS,
        value: operation.get('value') || '',
      });
    }

    case OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_DELETE: {
      return validateAndApply({
        type: ATTRIBUTE.INSTRUCTIONS,
        value: product
          .getIn([FORM.PERSONALIZATION, ATTRIBUTE.INSTRUCTIONS, VALUE])
          .replace(new RegExp(escapeRegex(operation.get('value')), 'ig'), ''),
      });
    }

    case OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_ADD_AFTER: {
      return validateAndApply({
        type: ATTRIBUTE.INSTRUCTIONS,
        value: `${product.getIn([FORM.PERSONALIZATION, ATTRIBUTE.INSTRUCTIONS, VALUE])}${operation.get('value')}`,
      });
    }

    case OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_ADD_BEFORE: {
      return validateAndApply({
        type: ATTRIBUTE.INSTRUCTIONS,
        value: `${operation.get('value')}${product.getIn([FORM.PERSONALIZATION, ATTRIBUTE.INSTRUCTIONS, VALUE])}`,
      });
    }

    case OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_FIND_AND_REPLACE: {
      return validateAndApply({
        type: ATTRIBUTE.INSTRUCTIONS,
        value: product
          .getIn([FORM.PERSONALIZATION, ATTRIBUTE.INSTRUCTIONS, VALUE])
          .replace(
            new RegExp(escapeRegex(operation.getIn(['value', 'find'])), 'ig'),
            operation.getIn(['value', 'replace'])
          ),
      });
    }

    case OPERATIONS[ETSY].PERSONALIZATION_QUESTIONS: {
      const questions = shapePersonalizationQuestionsForApp({ questions: operation.get('value') });
      const value = Map({ [VALUE]: questions, [PERSONALIZATION_TYPE.FILES]: personalizationHasFilesUpload(questions) });
      const errors = validatePersonalization({ channel: ETSY, personalization: value, userFeatures });
      return {
        actions,
        product: getSize(errors) > 0
          ? product
          : clearErrors({
            errors: [FORM.PERSONALIZATION],
            product: product.set(FORM.PERSONALIZATION, value),
          }),
      };
    }

    default: {
      return { actions, product };
    }
  }
}
